/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import { extend } from '@thd-nucleus/data-sources';
import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useBundleMiniFbtLayout } from '../hooks/useBundleMiniFbtLayout';
import { PackagesMiniAbTest } from './PackagesMiniAbTest';
import { RENDER_THD_RECS } from '../constants/index';
import { ProductDataModel } from '../models/dataModel';
import { shouldDisplayRecsFBT, shouldDisplayFbtbundle } from '../utils/product-utils';

const BundleFbt = ({ itemId, name = "" }) => {
  const { productData, referer } = useBundleMiniFbtLayout({ itemId });
  const fsRecsFBT = useConfigService("fs:isFbtRecsEnable");
  const shouldDisplayRecs =
    !shouldDisplayFbtbundle(productData) && shouldDisplayRecsFBT(productData, referer) && fsRecsFBT;

  if (!shouldDisplayRecs) return null;

  return (
    <div data-testid="fbt-recs" className="sui-w-full">
      <PackagesMiniAbTest itemId={itemId} renderComponent={RENDER_THD_RECS} name={name} />
    </div>
  );
};

BundleFbt.propTypes = {
  itemId: string.isRequired,
  name: string
};

BundleFbt.dataModel = extend(
  ProductDataModel,
  PackagesMiniAbTest,
  podFulFillmentUtils
);

BundleFbt.displayName = 'BundleFbt';

export { BundleFbt };